<template>
  <!-- 官网首页  -->
  <div>
    <!-- 头部链接 -->
    <global-header></global-header>
    <!-- <home-search></home-search> -->
    <!-- 首页巨幕 -->
    <div class="huge">
      <huge-screen></huge-screen>
    </div>
    <!-- 右边下单的广告 -->
    <div>
      <Adv></Adv>
    </div>
    <div class="center_container">
      <keep-alive>
        <new-list></new-list>
      </keep-alive>
    </div>
    <div class="center_container">
      <good-tab></good-tab>
    </div>
    <!-- <div class="center_container">
      <div class="md-layout md-gutter md-alignment-center">
        <div class="md-layout-item md-size-100">
          <diy-tab title="主题游" type="tab" color="#9c27b0" active>
            <diy-tab-item name="first" label="唐房">
               
            </diy-tab-item>
            <diy-tab-item name="second" label="复式房">Tab形式2</diy-tab-item>
            <diy-tab-item name="three" label="带厅复式">Tab形式2</diy-tab-item>
            <diy-tab-item name="four" label="豪华套房">Tab形式2</diy-tab-item>
          </diy-tab>
        </div>
      </div>
    </div> -->
    <div class="center_container">
      <div
        class="md-layout md-gutter md-alignment-center"
        style="align-items: flex-start;min-height:1300px;"
      >
        <div class="md-layout-item md-size-66 md-medium-size-66 md-small-size-66 md-xsmall-size-66">
          <diy-tab title="吃喝玩乐" type="tab" color="#5cabf1" activea @change="waterfallChange">
            <diy-tab-item name="all" label="全部">
              <water-fall
                :count="3"
                :height="`1300`"
                :data-option="{item:8}"
                :url-option="{start : 0,limit : 10,company_id: 66}"
                url="http://i-wq.net/wqproject_company/index.php/66?app=api&mod=User&act=companyFeed"
              />
            </diy-tab-item>
            <diy-tab-item name="first" label="云来客栈">
              <water-fall
                :count="3"
                :height="`1300`"
                :data-option="{item:8}"
                :url-option="{start : 0,limit : 10,company_id: 49}"
                url="http://i-wq.net/wqproject_company/index.php/66?app=api&mod=User&act=companyFeed"
              />
            </diy-tab-item>
            <diy-tab-item name="second" label="御瀛庄">
              <water-fall
                :count="3"
                :height="`1300`"
                :data-option="{item:8}"
                :url-option="{start : 0,limit : 10,company_id: 50}"
                url="http://i-wq.net/wqproject_company/index.php/66?app=api&mod=User&act=companyFeed"
              />
            </diy-tab-item>
            <diy-tab-item name="three" label="温泉区">
              <water-fall
                :count="3"
                :height="`1300`"
                :data-option="{item:8}"
                :url-option="{start : 0,limit : 10,company_id: 51}"
                url="http://i-wq.net/wqproject_company/index.php/66?app=api&mod=User&act=companyFeed"
              />
            </diy-tab-item>
            <diy-tab-item name="four" label="大餐庙会">
              <water-fall
                :count="3"
                :height="`1300`"
                :data-option="{item:8}"
                :url-option="{start : 0,limit : 10,company_id: 52}"
                url="http://i-wq.net/wqproject_company/index.php/66?app=api&mod=User&act=companyFeed"
              />
            </diy-tab-item>
          </diy-tab>
        </div>
        <div
          class="md-layout-item md-size-33 md-medium-size-33 md-small-size-33 md-xsmall-size-33 layout_right"
        >
          <diy-tab title="体验|福利" type="tab" color="#ffc107" active style="width:100%">
            <diy-tab-item name="first" label="">
              <md-card>
                <md-card-media-cover md-solid>
                  <md-card-media md-ratio="4:3">
                    <a href="https://mp.weixin.qq.com/s/DcN68xRv66bjIrBfBuGE5w" target="_bank">
                    <img
                      src="http://test.00800.com.cn/pc/20190710165908.jpg"
                    >
                    </a>
                  </md-card-media>

                  <md-card-area>
                    <md-card-header>
                      <span class="md-title">非常功道来啦</span>
                      <span class="md-subhead">阁下骨骼清奇，快来接受泉民挑战！</span>
                    </md-card-header>
                  </md-card-area>
                </md-card-media-cover>
              </md-card>

              <md-card>
                <md-card-media-cover md-solid>
                  <md-card-media md-ratio="4:3">
                    <a href="https://mp.weixin.qq.com/s/S4yWdjm8cm1HE1LtduE_Vg" target="_bank">
                    <img
                      src="http://test.00800.com.cn/pc/20190710165512.jpg"
                    >
                    </a>
                  </md-card-media>

                  <md-card-area>
                    <md-card-header>
                      <span class="md-title">这个父亲节</span>
                      <span class="md-subhead">相约御温泉“爸王之旅”！</span>
                    </md-card-header>
                  </md-card-area>
                </md-card-media-cover>
              </md-card>
            </diy-tab-item>
          </diy-tab>
          <Travel></Travel>
        </div>
      </div>
    </div>

    <div class="center_container"></div>
    <side-nav></side-nav>
    <Footer></Footer>
  </div>
</template>

<script>
import WaterFall from "@/components/WaterFall/index";
import Adv from '@/components/Adv/index'
import HomeSearch from "./components/HomeSearch";
import GlobalHeader from "@/components/GlobalHeader";
import HugeScreen from "@/components/HugeScreen/index";
// import Dynamic from './components/Dynamic'
import NewList from "./components/NewList";
import DiyTab from "@/components/DiyTab/index";
import DiyTabItem from "@/components/DiyTab/DiyTabItem";
import Footer from "@/components/Footer/index";
import SideNav from "@/components/SideNav/index";
import GoodList from "./components/GoodList";
import GoodTab from "./components/GoodTab";

import Travel from "@/views/travel/Travel";

import { searchGoods, searchGoodsByType } from "@/api/good";
export default {
  components: {
    WaterFall,
    HugeScreen,
    DiyTab,
    DiyTabItem,
    NewList,
    Footer,
    GoodList,
    GoodTab,
    SideNav,
    Travel,
    GlobalHeader,
    HomeSearch,
    Adv
    // DetailCard,
    // DetailItem
  },
  created() {
    this.getGoodInfo();
  },
  data() {
    return {
      urlOption: {
        method: "Get"
      },
      activeNames: ["1"],
      goodTypes: [],
      goodList: []
    };
  },
  mounted() {
    // console.log(this.$refs);
  },
  methods: {
    
    getGoodInfo() {
      const store_no = 50;
      const type = 2;
      searchGoods(store_no, type).then(res => {
        this.goodTypes = res.data.type;

        // console.log(res.data.type);
        this.goodTypes.forEach(type => {
          searchGoodsByType(type.shop_id, type.id).then(res => {
            this.goodList.push(res.data.goods);
          });
        });
        // console.log(this.goodList);
      });
    },
    waterfallChange(e){
      console.log(e)
    }
  }
};
</script>

<style lang="scss" >
.huge {
  width: 100vw;
  min-width: 1120px;
}

.center_container {
  margin: 0 auto;
  width: 1120px;
}
// @media screen and(max-width: 1120px){
//   .center_container {
//     margin: 0 auto;
//     width: 80vw;
//   }
// }

// @media screen and(min-width: 1120px){
//   .center_container {
//     margin: 0 auto;
//     width: 1120px;
//   }
// }

.layout_right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>

